import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'UserSearchPipe', pure: true,
    standalone: false
})
export class UserSearchPipe implements PipeTransform {
  transform(value: any[] | null | undefined, args?: string): Array<any> {
    if (!value || !value.length) return [];
    if (!args || typeof args !== 'string' || args.trim() === '') return value;
    try {
      const searchText = new RegExp(args.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
      return value.filter(user => {
        const fullName = user?.fullName ?? '';
        const enFullName = user?.enFullName ?? '';
        const email = user?.email ?? '';
        const studentFullName = (user?.studentProfile?.fullName ?? '') + ' ' + (user?.studentProfile?.lastName ?? '');
        const studentEnFullName = (user?.studentProfile?.enFullName ?? '') + ' ' + (user?.studentProfile?.enLastName ?? '');
        
        return searchText.test(fullName) || 
               searchText.test(enFullName) || 
               searchText.test(email) || 
               searchText.test(studentFullName) || 
               searchText.test(studentEnFullName);
      });
    } catch {
      return value;
    }
  }
}
